export default __webpack_public_path__ + "static/media/checkbox-empty.8fb047d7.svg";